module KendoWidgets
{
	export class QRCodeOptions implements kendo.dataviz.ui.QRCodeOptions
	{
		background?: string;
		border?: kendo.dataviz.ui.QRCodeBorder;
		color?: string;
		encoding?: string;
		padding?: number;
		width?: number | string;
		value?: number | string;
	}

	export class QRCode extends kendo.dataviz.ui.QRCode implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.QRCode; }
		private _value: string;

		constructor(element: Element, options?: KendoWidgets.QRCodeOptions)
		{
			if (options == null)
				options = new KendoWidgets.QRCodeOptions();

			(options as any).errorCorrection = "H";
			(options as any).size = options.width;

			super(element, options);
		}

		value(value?: string | number)
		{
			if (value != null)
			{
				value = String(value);
				super.value(value);
				this._value = value;
			}
			return this._value;
		}

		public clear()
		{
			this._value = "";
			super.value("");
		}

		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.prependTo(element);
		}
	}

	QRCode.fn = QRCode.prototype;
	QRCode.fn.options = $.extend(true, {}, kendo.dataviz.ui.QRCode.fn.options);
	QRCode.fn.options.name = "QRCode";
	kendo.ui.plugin(QRCode);
}

interface JQuery
{
	kendoQRCode(options?: KendoWidgets.QRCodeOptions): JQuery;
}